import React from 'react';
import StoreDropdown from './store_dropdown';
import { trackEvent } from '../../../../utils';

const updateStorePreference = (storePreference, currentStore) => {
   new Request.API_2_0('store/user/store_preference', {
      method: 'POST',
      onSuccess: () => {
         trackEvent(
            'Preferred Store',
            `${currentStore.storeCode} - ${storePreference.storeCode}`,
            window.location.href
         );
         if (App.storeRedirectLinks && App.storeRedirectLinks[storePreference.storeCode]) {
            window.location = App.storeRedirectLinks[storePreference.storeCode];
         } else if (App.onStorePage && App.storeUrls) {
            window.location = App.storeUrls[storePreference.storeCode];
         } else {
            window.location.reload();
         }
      },
      statusPanelMessage: _js('Submitting'),
   }).send({
      newStore: storePreference.storeCode,
   });
};

const IFixitStoreDropdown = ({ stores, mobile, currentStore }) => (
   <StoreDropdown
      stores={stores}
      mobile={mobile}
      onClickStore={store => updateStorePreference(store, currentStore)}
   ></StoreDropdown>
);

export default IFixitStoreDropdown;
